import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import vehicle from "../../../containers/modules/master/vehicle";

export default function VehicleRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="vehicle"
      index
      element={
        <AccessControl
          name={"Vehicle List"}
          auth={authUser}
          component={vehicle}
        />
      }
    />
  );
}
